import * as React from 'react';
import { SVGProps } from 'react';

const XslFileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="64"
    height="65"
    viewBox="0 0 64 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 6.0873V58.9127C16 61.9985 18.4624 64.5 21.5 64.5H58.5C61.5376 64.5 64 61.9985 64 58.9127V15.2025C64 13.71 63.4122 12.2796 62.3677 11.2301L53.2957 2.11483C52.266 1.08026 50.8762 0.5 49.428 0.5H21.5C18.4624 0.5 16 3.00152 16 6.0873ZM19.5 58.9127V6.0873C19.5 4.9652 20.3954 4.05556 21.5 4.05556H48.75V16.246C48.75 18.35 50.4289 20.0556 52.5 20.0556H60.5V58.9127C60.5 60.0348 59.6046 60.9444 58.5 60.9444H21.5C20.3954 60.9444 19.5 60.0348 19.5 58.9127ZM60.5 16.5V15.2025C60.5 14.6598 60.2863 14.1396 59.9064 13.758L52.25 6.06509V16.246C52.25 16.3863 52.3619 16.5 52.5 16.5H60.5Z"
      fill="#9D9C9B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41 26.75C41 25.7835 41.7835 25 42.75 25H54.25C55.2165 25 56 25.7835 56 26.75C56 27.7165 55.2165 28.5 54.25 28.5H42.75C41.7835 28.5 41 27.7165 41 26.75Z"
      fill="#69C997"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41 34.75C41 33.7835 41.7835 33 42.75 33H54.25C55.2165 33 56 33.7835 56 34.75C56 35.7165 55.2165 36.5 54.25 36.5H42.75C41.7835 36.5 41 35.7165 41 34.75Z"
      fill="#54AD7D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41 42.75C41 41.7835 41.7835 41 42.75 41H54.25C55.2165 41 56 41.7835 56 42.75C56 43.7165 55.2165 44.5 54.25 44.5H42.75C41.7835 44.5 41 43.7165 41 42.75Z"
      fill="#2B593D"
    />
    <path
      d="M0 19C0 17.3431 1.34315 16 3 16H33C34.6569 16 36 17.3431 36 19V49C36 50.6569 34.6569 52 33 52H3C1.34315 52 0 50.6569 0 49V19Z"
      fill="#3D8A58"
    />
    <path
      d="M10 44.043L15.6191 33.584L10.5195 24H14.4023L17.6973 30.4395L20.9238 24H24.7656L19.666 33.7344L25.2852 44.043H21.2793L17.6289 37.1113L13.9785 44.043H10Z"
      fill="white"
    />
  </svg>
);

export default XslFileIcon;
